import React, { useEffect, useState } from 'react';
import Input from '../../input/input';
import Menu from '../../menu/menu';
import Button from '../../button/button';
import { ArrowsDownUp, MagnifyingGlass } from '@phosphor-icons/react';

const Header = (props) => {
  const {
    showSearch,
    sorts,
    searchText,
    appliedSorts,
    onChange,
    headerItems,
  } = props;

  const [search, setSearch] = useState('');

  useEffect(() => {
    setSearch(searchText);
  }, [searchText]);

  const triggerIcon = (
    <Button
      iconLeft={<ArrowsDownUp color="#878787" />}
      type="tertiary"
      size="small"
      className="sort-button"
    >
      Sort
    </Button>
  );

  const onKeyDown = (e) => {
    if (e?.key === 'Enter') onChange('search', search);
  };

  return (
    <header className="table-header-container flex gap-3 items-center pb-9">
      {showSearch && (
        <Input
          value={search}
          onChange={(e) => setSearch(e?.target?.value)}
          iconLeft={<MagnifyingGlass color="#878787"
            size={24} />}
          onKeyDown={onKeyDown}
          onBlur={(e) => onChange('search', e?.target?.value)}
          placeholder="Search"
          className="table-search-input"
        />
      )}
      {!!sorts?.length && (
        <Menu
          className="sorts-menu"
          menuItems={sorts}
          value={appliedSorts?.value}
          triggerIcon={triggerIcon}
          offset={[0, 8]}
          onClick={(item) => onChange('sort', item)}
        />
      )}
      {headerItems}
    </header>
  );
};

export default Header;
